export const abcFields = [
  'amount',
  'balance',
  'withdrawnAmount',
  'leftAmount',
  'initialDepositAbc',
  'reDepositAbc',
  'depositAbc',
  'netDepositAbc',
  'withdrawRequestAbc',
  'withdrawAbc',
  'creditAbc',
  'debitAbc',
  'pnlAbc',
  'otherPnlAbc',
  'tradingCommissionAbc',
  'rolloverCommissionAbc',
  'swapAbc',
  'pullbackAbc',
  'chargebackAbc',
  'chargebackReversalAbc',
  'recallAbc',
  'recallReversalAbc',
  'quantityAbc',
  'averageDealSizeAbc',
  'lifetimeInitialDepositAbc',
  'balanceAbc',
  'netCreditAbc',
  'creditVolumeIsNeededAbc',
  'creditVolumeIsNotNeededAbc',
  'debitVolumeIsNeededAbc',
  'debitVolumeIsNotNeededAbc',
  'netCreditVolumeIsNeededAbc',
  'netCreditVolumeIsNotNeededAbc',
  'equityAbc',
  'openPnlAbc',
  'shortVolumeAbc',
  'lockVolumeAbc',
  'openSwapAbc',
  'postBalance',
  'freeBalanceAbc',
  'marginUsedAbc',
  'volumeAbc',
  'postBalanceAbc',
  'spreadAbc',
  'lockingVolumeAbc',
  'totalDebitAbc',
  'totalCreditAbc',
  'totalRedepositAbc',
  'totalInitialDepositAbc',
  'totalPnlAbc',
  'totalRecallReversalAbc',
  'totalRecallAbc',
  'totalChargebackReversalAbc',
  'totalChargebackAbc',
  'totalWithdrawalsAbc',
  'totalShortPnlAbc',
  'totalDebitBalanceCorrectionAbc',
  'totalCreditBalanceCorrectionAbc',
  'totalLockingVolumeAbc',
  'totalShortVolumeAbc',
  'totalSwapAbc',
  'totalCommissionsAbc',
  'totalDepositsAbc',
];
